<template>

  <Permessi />

</template>

<script>
import Permessi from '../components/Permessi.vue'

export default {
  pageName: '',
  components: {
    Permessi

  },
  data() {
    return {

    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },

  methods: {
    
  },
}
</script>
